<template>
  <Modal :is_show="showModal" class="new-chat-modal" @click-bg="close">
    <Loading class="static" v-if="isLoading" />

    <div class="box" v-else>
      <header>
        <h2>New Chat</h2>
      </header>
      <div class="form-item">
        <label>To</label>
        <el-select
          v-model="value"
          multiple
          filterable
          default-first-option
          :reserve-keyword="false"
          placeholder="Search creator name or tag"
        >
          <el-option v-for="item in users" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
        <p>* Messages sent to more than one creator will be sent as individual chats.</p>
      </div>

      <div class="form-item">
        <label>Message:</label>
        <el-input
          v-model="message"
          maxlength="500"
          placeholder="New message"
          show-word-limit
          rows="6"
          type="textarea"
        />
      </div>

      <p v-if="isShowError1" class="error-msg">Please select at least one creator.</p>
      <p v-if="isShowError2" class="error-msg">Cannot send empty chats.</p>

      <footer>
        <el-button @click="close">Cancel</el-button>
        <el-button type="primary" @click="send" border_r="6" :loading="isSending">Send</el-button>
      </footer>
    </div>
  </Modal>
</template>

<script setup>
import { ref, getCurrentInstance } from 'vue';
import Modal from '../ui/Modal.vue';
import Loading from '../ui/Loading.vue';
import { ElSelect, ElOption, ElInput, ElButton } from 'element-plus';
import log from '../../utils/Log';

const app = getCurrentInstance();
const ajax = app.appContext.config.globalProperties.$ajax;
const showModal = ref(false);
const users = ref([]);
const isLoading = ref(true);
const isSending = ref(false);
const value = ref('');
const message = ref('');
const isShowError1 = ref(false);
const isShowError2 = ref(false);

const getUsers = () => {
  const ajaxs = [
    ajax.get('/chatroom/get-creator-list?status=active'),
    // ajax.get('/chatroom/get-creator-list?status=inactive'),
    ajax.get('/chatroom/get-creator-list?status=muted'),
    ajax.get('/creator/get-ambassador-tag-list'),
  ];

  Promise.all(ajaxs).then((res) => {
    log('blue', 'users', res);

    users.value = [...res[0].data.data, ...res[1].data.data];

    res[2].data.data.forEach((item) => {
      users.value.push({
        id: item.id,
        name: 'Tag:' + item.tag,
        is_tag: true,
      });
    });
    isLoading.value = false;
    // log('blue', 'users', users.value);
  });
};

const send = () => {
  if (value.value.length === 0 || message.value === '') {
    isShowError1.value = value.value.length === 0;
    isShowError2.value = message.value === '';
    return;
  }

  isShowError1.value = false;
  isShowError2.value = false;
  isSending.value = true;

  const data = {
    // creator_portal_user_ids: value.value,
    message_text: message.value,
  };
  const ambassador_program_tag_ids = [];
  const creator_portal_user_ids = [];

  value.value.forEach((item) => {
    if (users.value.find((user) => user.id === item).is_tag) {
      ambassador_program_tag_ids.push(item);
    } else {
      creator_portal_user_ids.push(item);
    }
  });

  if (ambassador_program_tag_ids.length > 0) {
    data.ambassador_program_tag_ids = ambassador_program_tag_ids;
  }

  if (creator_portal_user_ids.length > 0) {
    data.creator_portal_user_ids = creator_portal_user_ids;
  }

  log('blue', 'send ids', data);

  ajax.post('/chatroom/send-new-message', data).then((res) => {
    log('green', 'Send message', res);
    close();
  });
};

const open = () => {
  if (users.value.length === 0) {
    getUsers();
  } else {
    isLoading.value = false;
  }

  showModal.value = true;
};

const close = () => {
  console.log('close');

  showModal.value = false;
  message.value = '';
  value.value = '';
  isSending.value = false;
  isShowError1.value = false;
  isShowError2.value = false;
};

defineExpose({
  open,
  close,
});
</script>

<style lang="scss">
.new-chat-modal {
  z-index: 90;

  .box {
    padding: 24px;

    & > header {
      margin-bottom: 16px;

      h2 {
        font: var(--medium-24);
      }
    }

    .form-item {
      margin-bottom: 16px;

      label {
        display: block;
        margin-bottom: 8px;
        font: var(--medium-16);
      }

      p {
        margin-top: 8px;
        font: var(--book-14);
        color: var(--Text-default);
      }
    }

    .error-msg {
      margin-bottom: 4px;
      font: var(--book-12);
      color: var(--Red-30);
    }

    footer {
      display: flex;
      margin-top: 24px;

      .el-button + .el-button {
        flex: 1;
        align-items: center;
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>
